import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { PipesModule } from '../../pipes/pipes.module';
import { TimeAgoComponent } from './time-ago.component';

@NgModule({
  declarations: [TimeAgoComponent],
  exports: [TimeAgoComponent],
  imports: [CommonModule, PipesModule],
})
export class TimeAgoModule {}
